import React, { useMemo } from 'react';
import { Box } from '@withjoy/joykit';
import { PhotoCarousel } from '@shared/components/PhotoCarousel';
import { ListingWithPricing } from '@apps/accommodations/AccommodationsConsole.types';
import { Skeleton } from '@shared/components/Skeleton';

const Container = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box aspectRatio=".96 / 1.25" maxWidth={220} minWidth={220}>
      {children}
    </Box>
  );
};

const ListingPhotos = ({ listing }: { listing: ListingWithPricing }) => {
  const images = useMemo(() => {
    return listing.photos.map(x => ({
      src: x.url,
      alt: listing.name
    }));
  }, [listing]);
  return (
    <Container>
      <PhotoCarousel borderRadius="10px" aspectRatio=".96 / 1.25" navigation={{ variant: 'minimal', visible: 'default' }} images={images} />
    </Container>
  );
};

ListingPhotos.Skeleton = () => {
  return (
    <Container>
      <Skeleton borderRadius="10px" width="100%" height="100%" />
    </Container>
  );
};

export { ListingPhotos };
